const CartActionTypes = {
    TOGGLE_CART_HIDDEN: "TOGGLE_CART_HIDDEN",
    ADD_CART_ITEM: "ADD_CART_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
    REMOVE_CART_ITEM: "REMOVE_CART_ITEM",
};

export default CartActionTypes;